import type { ReactElement } from "react";
import { Typography } from "@mui/material";
import type { TFunction } from "i18next";
import styles from "@/routes/lms/lmsCourseOverview.module.css";

interface Props {
  canDeleteCourse: boolean;
  deleteCourseButton: ReactElement;
  isLoading: boolean;
  t: TFunction;
}

export default function LmsCourseOverviewDangerZone({
  canDeleteCourse,
  deleteCourseButton,
  isLoading,
  t,
}: Props) {
  if (isLoading || !canDeleteCourse) {
    return null;
  }

  return (
    <div className={styles.deleteCourseSection}>
      <div className={styles.deleteCoursePanel}>
        <div>
          <Typography component="h3" className={styles.deleteCourseTitle}>
            {t("lms_delete_course_section_title")}
          </Typography>
          <Typography className={styles.deleteCourseDescription}>
            {t("lms_delete_course_section_description")}
          </Typography>
        </div>
        <div className={styles.deleteCourseActions}>{deleteCourseButton}</div>
      </div>
    </div>
  );
}
